import React from "react";
import { useRecoilValue } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import DashboardTab, {
  dashboardTabState,
} from "../../components/pages/Dashboard/DashboardTab";
import PartyBoard from "../../components/pages/Dashboard/PartyBoard";
import PayBoard from "../../components/pages/Dashboard/PayBoard";
import PromotionBoard from "../../components/pages/Dashboard/PromotionBoard";
import UserBoard from "../../components/pages/Dashboard/UserBoard";

export default function DashBoard() {
  const dashboardTab = useRecoilValue(dashboardTabState);

  return (
    <>
      <PageTitle title="대시보드" />

      <DashboardTab />

      {dashboardTab === 0 ? (
        <UserBoard />
      ) : dashboardTab === 1 ? (
        <PartyBoard />
      ) : dashboardTab === 2 ? (
        <PayBoard />
      ) : dashboardTab === 3 ? (
        <PromotionBoard />
      ) : (
        <></>
      )}
    </>
  );
}
